import { render, staticRenderFns } from "./StatusSummaryCard.vue?vue&type=template&id=6541696a&scoped=true&lang=pug"
import script from "./StatusSummaryCard.vue?vue&type=script&lang=js"
export * from "./StatusSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./StatusSummaryCard.vue?vue&type=style&index=0&id=6541696a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541696a",
  null
  
)

export default component.exports